module.exports = __webpack_public_path__ + "img/tob_10.81727b23.svg";